'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './client-edit.routes';

export class ClientSettingsEditComponent {
  constructor(SettingsService, Auth, $state, dialogs, TemplateService, EFormsService, $scope, $uibModal, User) {
    'ngInject';

    this.SettingsService = SettingsService;
    this.dialogs = dialogs;
    this.$state = $state;
    this.$scope = $scope;
    this.$uibModal = $uibModal;

    Auth.isSuperAdmin(isSuperAdmin => {
      if (isSuperAdmin) {
        SettingsService.getSystemInfo(systemInfo => this.systemInfo = systemInfo);
        SettingsService.getCacheStats(cacheStats => this.cacheStats = cacheStats);
        SettingsService.getByName({name: 'client'}, clientSettings => this.useLocalLedger = clientSettings.data.useLocalLedger);
      }
    });

    this.toolbarDefinition = [
      ["bold","italics","underline"],
      ["h3","h4","h5"],
      ["p","quote","clear"],
      ["ul","ol"],
      ["justifyLeft","justifyCenter","justifyRight","justifyFull"],
      ["undo","redo"]
    ];

    this.count = 0;
    this.maxCount = 2;

    TemplateService.query(data => {
      this.templates = data;
      this.templatesData = data.map(entity => {
        return {
          value: entity._id,
          name: entity.name,
          group: "Letter Templates"
        }
      });

      this.count++;
      if (this.count == this.maxCount)
        fnReady();
    });

    EFormsService.query(data => {
      this.eforms = data;
      this.eformsData = data.map(entity => {
        return {
          value: entity._id,
          name: entity.name,
          group: "E-Forms"
        }
      });

      this.count++;
      if (this.count == this.maxCount)
        fnReady();
    });

    this.SettingsService.getByName({name: 'custom-fields'}, customFieldSettings => {
      if (customFieldSettings.data.hasOwnProperty("client")) {
        this.customSchema = customFieldSettings.data.client;
        this.customForm = ["*"];
      }
    });


    let fnReady = _ => {
      this.SettingsService.getByName({name: "client"}, data => {
        this.settings = data;

        this.schemaClient = {
          type: "object",
          properties: {
            clientName: {
              type: "string",
              title: "Association Name"
            },
            name: {
              type: "string",
              title: "Management Company Name"
            },
            address: {
              type: "string",
              title: 'Address of Management Company'
            },
            phone: {
              title: "Phone Number",
              type: "string"
            },
            fax: {
              title: "Fax Number",
              type: "string"
            }
          }
        };

        this.schemaGeneral = {
          type: "object",
          properties: {
            quorum: {
              type: "number",
              title: "Default Quorum",
              description: "Remark: A value of 0.4 means 40%",
              minimum: 0.01,
              maximum: 1
            },
            weightVisible: {
              type: "boolean",
              title: "Property Weight Visible?",
              description: "When you have different weighted properties in your association"
            },
            buildingNoVisible: {
              type: "boolean",
              title: "Building Number Visible?",
              description: "When the Unit Number alone is not sufficient to identify the property"
            },
            adminsCannotChangeVotes: {
              type: "boolean",
              title: "Admins are not allowed to change non-secret e-votes"
            },
            boardResolution: {
              "type": "string",
              "title": "Board Resolution",
              "x-schema-form": {
                "type": "single-file-upload"
              },
              "fnOpenAssetUploadModal": key => {
                this.openAssetUploadModal(key);
              }
            }
          }
        };

        this.schemaAppearance = {
          type: "object",
            properties: {
            frontpage: {
              "type": "string",
                "title": "Frontpage Image",
                "x-schema-form": {
                "type": "single-file-upload"
              },
              "fnOpenAssetUploadModal": key => {
                this.openAssetUploadModal(key);
              }
            },
            background: {
              "type": "string",
              "title": "Background Image",
              "x-schema-form": {
                "type": "single-file-upload"
              },
              "fnOpenAssetUploadModal": key => {
                this.openAssetUploadModal(key);
              }
            }/*,
            theme: {
              "type": "string",
              "title": "Theme",
              "x-schema-form": {
                "enum": ["spacelab","cerulean","cosmo"]
              },
              "fnOpenAssetUploadModal": key => {
                this.openAssetUploadModal(key);
              }
            }*/
          }
        };

        let eformLookupFn = (key) => {
          this.genericLookup(key, {
            title: "E-Forms",
            data: this.eforms,
            columns: [{
              name: "Name",
              data: "name"
            },{
              name: "Description",
              data: "description"
            }]
          });
        };

        let templateLookupFn = (key) => {
          this.genericLookup(key, {
            title: "Letter Templates",
            data: this.templates,
            columns: [{
              name: "Name",
              data: "name"
            },{
              name: "Description",
              data: "description"
            }]
          });
        };

        this.schemaOptInOut = {
          type: "object",
          properties: {
            optInOut: {
              "type": "object",
              "x-schema-form": {
                "notitle": true,
              },
              "properties": {
                required: {
                  type: "boolean",
                  title: "Opt-in/out Required?",
                  description: "Remark: Required in Florida"
                },
                hidden: {
                  type: "boolean",
                  title: "Online Opt-in/out hidden?",
                  description: "When you don't want to allow the owners to opt-in/out online in the voting software"
                },
                optInForm: {
                  type: "string",
                  title: "Opt-in E-Form",
                  entityLookupData: this.eformsData,
                  fnLookup: eformLookupFn,
                  "x-schema-form": {
                    //fieldHtmlClass: "col-xs-6",
                    type: "entitylookup",
                    lookuptype: "eform"
                  }
                },
                optOutForm: {
                  type: "string",
                  title: "Opt-out E-Form",
                  entityLookupData: this.eformsData,
                  fnLookup: eformLookupFn,
                  "x-schema-form": {
                    //fieldHtmlClass: "col-xs-6",
                    type: "entitylookup",
                    lookuptype: "eform"
                  }
                }
              }
            }
          }
        };

        this.schemaProxy = {
          type: "object",
          properties: {
            proxy: {
              "type": "object",
              "x-schema-form": {
                "notitle": true,
              },
              "properties": {
                canVote: {
                  type: "boolean",
                  title: "Proxy can vote",
                  description: "Remark: Only in HOAs, not Condos"
                },
                hidden: {
                  type: "boolean",
                  title: "Proxy hidden",
                  description: "When you don't want to allow the owners to set or remove a proxy online in the voting software"
                },
                onlyDefaultProxy: {
                  type: "boolean",
                  title: "Only Default Proxy",
                  description: "Owner can only choose the default proxy holder and not a self-chosen one",
                  "x-schema-form": {
                    "condition": "!model.proxy.hidden"
                  }
                }
              }
            }
          }
        };

        this.schemaLetterTemplates = {
          type: "object",
          properties: {
            templateAddressLabels: {
              type: "string",
              title: "Address Labels Template",
              entityLookupData: this.templatesData,
              fnLookup: templateLookupFn,
              "x-schema-form": {
                type: "entitylookup",
                lookuptype: "template"
              }
            },
            templateCoverLetter: {
              type: "string",
              title: "Cover Letter Template",
              entityLookupData: this.templatesData,
              fnLookup: templateLookupFn,
              "x-schema-form": {
                type: "entitylookup",
                lookuptype: "template"
              }
            }
          }
        };

        this.form = [
          "*"
        ];

        this.model = this.settings.data;
        this.customFields = this.model.customFields || {};

        this.$scope.$broadcast('schemaFormRedraw');

      }, err => {
        console.log('Could not load settings from server');
      });
    }
  }

  openAssetUploadModal(key) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetUpload',
      resolve: {
        config: function() {
          return {}
        }
      }
    });

    modalInstance.result.then(
      function (result) {

        if (result && result.length > 0) {
          that.model[key] = result[0];

          //that.getAttachmentFilename();
        }

      },
      function () { /* cancel */ }
    );

  }

  genericLookup(key, config) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'genericLookup',
      resolve: {
        config: function() {
          return config
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (entity) {

        if (!Array.isArray(key)) {
          that.model[key] =  entity._id;
        } else {
          let len = key.length;

          //todo: yes, i know (same in addCustomFieldsCache)
          switch(len) {
            case 1: that.model[key[0]] = entity._id; break;
            case 2: that.model[key[0]][key[1]] = entity._id; break;
            case 3: that.model[key[0]][key[1]][key[2]] = entity._id; break;
            case 4: that.model[key[0]][key[1]][key[2]][key[3]]= entity._id; break;
          }
        }
      },
      function () { /* cancel */ }
    );

  }

  refreshCache() {
    this.SettingsService.getCacheStats(cacheStats => this.cacheStats = cacheStats);
  }

  flushCache() {
    this.SettingsService.flushCache();
  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {

      var onSuccess = () => {
        var dlg = this.dialogs.notify("Success", "The client settings have been changed successfully");
        dlg.result.then(() => {
          that.$state.go("admin-home");
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      this.settings.data = this.model;
      this.model.customFields = this.customFields || {};

      this.SettingsService.update({id: this.settings._id}, this.settings, onSuccess, onError);
    }
  }
}

export default angular.module('conduu.clientSettingsEdit', [uiRouter])
  .config(routes)
  .component('clientSettingsEdit', {
    template: require('./client-edit.html'),
    controller: ClientSettingsEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/admin/client-edit/client-edit.component.js